<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'satisfaction.callHistoryModal.title' | translate }}</h3>
      <button class="btn-close" (click)="onClose()">&times;</button>
    </div>

    <div class="modal-body" *ngIf="feedback">
      <div class="feedback-info">
        <p><strong>{{ 'satisfaction.common.patientLabel' | translate }}</strong> {{ feedback.contact_tel || 'satisfaction.common.notProvided' | translate }}</p>
        <p><strong>{{ 'satisfaction.common.feedbackDateLabel' | translate }}</strong> {{ formatDate(feedback.created_at) }}</p>
        <p><strong>{{ 'satisfaction.common.ratingLabel' | translate }}</strong> {{ '⭐'.repeat(feedback.score || 0) }} ({{ feedback.score }}/5)</p>
      </div>

      <div class="history-section">
        <h4>{{ 'satisfaction.common.patientCommentHeading' | translate }}</h4>
        <div class="comment-box">
          {{ feedback.comment || 'satisfaction.common.noComment' | translate }}
        </div>
      </div>

      <div class="history-section" *ngIf="feedback.replied_at">
        <h4>{{ 'satisfaction.callHistoryModal.callDoneHeading' | translate }}</h4>
        <div class="reply-info">
          <p><strong>{{ 'satisfaction.callHistoryModal.callDateLabel' | translate }}</strong> {{ formatDate(feedback.replied_at) }}</p>
          <p *ngIf="feedback.replied_by_name"><strong>{{ 'satisfaction.common.agentLabel' | translate }}</strong> {{ feedback.replied_by_name }}</p>
        </div>
        <div class="reply-content">
          <div class="content-header">
            <h5>{{ 'satisfaction.common.voicemailContentLabel' | translate }}</h5>
            <button class="btn-edit" (click)="toggleEdit()" [title]="'common.actions.edit' | translate">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </button>
          </div>
          <textarea *ngIf="isEditing" class="edit-textarea" [(ngModel)]="editedContent" rows="4"></textarea>
          <div *ngIf="!isEditing && feedback.reply_content" class="mail-content">
            {{ feedback.reply_content }}
          </div>
          <div *ngIf="!isEditing && !feedback.reply_content" class="mail-content empty">
            {{ 'satisfaction.callHistoryModal.noVoicemailContent' | translate }}
          </div>
          <div *ngIf="isEditing" class="edit-actions">
            <button class="btn-cancel-edit" (click)="cancelEdit()">{{ 'common.actions.cancel' | translate }}</button>
            <button class="btn-save-edit" (click)="saveEdit()">{{ 'common.actions.save' | translate }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancel" (click)="onClose()">{{ 'common.actions.close' | translate }}</button>
    </div>
  </div>
</div>
